import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["stroke"];
var _templateObject;
import React from 'react';
import styled from 'styled-components';
var Svg = styled.svg(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fill: currentColor;\n  width: 24px;\n  height: 24px;\n  display: inline-block;\n  font-size: 24px;\n  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  flex-shrink: 0;\n  user-select: none;\n"])));
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
});
var ArrowLeft = function ArrowLeft(_ref) {
  var stroke = _ref.stroke,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24"
  }, props), _ref2, _ref3);
};
export default ArrowLeft;